export const SLOT_COUNT = 8;

/**
 * Stable per-field tag slot (1–8). Hash a field's identifier so the SAME field
 * always renders in the SAME tag-slot color across the whole app (content card,
 * detail slide-over, etc.). Color groups by field, never by value/meaning.
 */
export function slotFor(fieldKey: string): number {
  let h = 0;
  for (let i = 0; i < fieldKey.length; i++) h = (h * 31 + fieldKey.charCodeAt(i)) >>> 0;
  return (h % SLOT_COUNT) + 1;
}
